import type {
  ContentDefinition,
  ForBlock,
  PluginDefinition,
} from "@magic-md/core";

export interface EngineUnitDescriptor {
  unitType: string;
  id: string;
  pluginName?: string;
  config?: Record<string, unknown>;
  configMode?: "external" | "inline";
  configExternalError?: string;
  isTemplate?: boolean;
  body?: string;
  params?: string[];
  block?: ForBlock;
}

export interface EngineUnitMaps {
  engineDefinitions: Map<string, PluginDefinition>;
  engineContentDefinitions: Map<string, ContentDefinition>;
  engineForBlocks: Map<string, ForBlock>;
}

/** Converts Engine wire descriptors into the editor's parsed-unit projection. */
export function buildEngineUnitMaps(
  units: readonly EngineUnitDescriptor[],
): EngineUnitMaps {
  const engineDefinitions = new Map<string, PluginDefinition>();
  const engineContentDefinitions = new Map<string, ContentDefinition>();
  const engineForBlocks = new Map<string, ForBlock>();

  for (const unit of units) {
    if (unit.unitType === "definition" && unit.pluginName) {
      engineDefinitions.set(unit.id, {
        id: unit.id,
        pluginName: unit.pluginName,
        config: unit.config ?? {},
        configMode: unit.configMode,
        configExternalError: unit.configExternalError,
        template: unit.isTemplate ?? false,
        params: unit.params,
      });
    } else if (unit.unitType === "content") {
      engineContentDefinitions.set(unit.id, {
        id: unit.id,
        kind: "content",
        template: unit.isTemplate ?? false,
        body: unit.body ?? "",
        params: unit.params,
        range: { start: 0, end: 0 },
      });
    } else if (unit.unitType === "for" && unit.block) {
      engineForBlocks.set(unit.id, unit.block);
    }
  }

  return {
    engineDefinitions,
    engineContentDefinitions,
    engineForBlocks,
  };
}
